export default __webpack_public_path__ + "static/media/insight-rego.a3245750.svg";